import React, { useEffect, useState } from 'react'
import { pageTitle } from '../common/cssclasses'
import { useTranslate } from '../components/TranslationText';
import NewsFilter from '../components/NewsComponents/NewsFilter';
import NewsCard from '../components/NewsComponents/NewsCard';
import { getNews } from '../components/NewsComponents/api/newsApi';
import NewActionButton from '../components/ActionButtons/NewActionButton';

export default function NewsPage({ toast, windowWidtht }) {
  const postsPerPage = 12;
  const { translate } = useTranslate();
  const [newsItems, setNewsItems] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]); // <-- store filtered list
  const [filter, setFilter] = useState({
    dateFrom: null,
    dateTo: null,
    title: ''
  });
  const [visibleCount, setVisibleCount] = useState(postsPerPage);

  useEffect(() => {
    getNews().then(res => {
      setNewsItems(res);
      setFilteredItems(res); // initially show all
    });
  }, []);

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + postsPerPage);
  };

  function doFilter(myfilter = filter) {
    let result = [...newsItems];

    result = result.filter(item => {
      let isValid = true;

      const itemDate = new Date(item?.date);

      if (myfilter?.dateFrom) {
        const fromDate = new Date(myfilter.dateFrom);
        if (itemDate < fromDate) isValid = false;
      }

      if (myfilter?.dateTo) {
        const toDate = new Date(myfilter.dateTo);
        if (itemDate > toDate) isValid = false;
      }

      if (myfilter?.title && !item.name.toLowerCase().includes(myfilter?.title.toLowerCase())) {
        isValid = false;
      }

      return isValid;
    });

    setFilteredItems(result);
    setVisibleCount(postsPerPage); // reset pagination when filtering
  }

  return (
    <div className='row pt-3'>
      <h2 className={pageTitle + " col-lg-12 col-sm-10 col-8 mb-3"}> {translate('web.news', 'News')} </h2>
      <div className={pageTitle + " d-md-none d-sm-block col-sm-2 col-4 mb-3"}> <NewActionButton title={translate('web.filter', 'Filter')} onClick={(e) => setShowFilter(!showFilter)} classNames='btn-outline-success px-1' text={<><i className='fa-solid fa-filter' ></i></>} /> </div>
      <div className={`col-lg-3 d-md-block col-sm-12 ${showFilter ? 'd-sm-block d-block' : 'd-sm-none d-none'} mb-3`}>
        <NewsFilter filter={filter} setFilter={setFilter} doFilter={doFilter} />
      </div>
      <div className='col-lg-9 col-sm-12 col-12'>
        <div className='row'>
          {filteredItems.slice(0, visibleCount).map((item, index) => (
            <div className='col-lg-6 col-md-6 col-sm-12 col-12 mb-4' key={index}>
              <NewsCard windowWidtht={windowWidtht} item={item} />
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {visibleCount < filteredItems.length && (
          <div className="text-center mb-3">
            <NewActionButton
              classNames='btn w-unset btn-outline-success px-4 py-2 rounded'
              onClick={handleLoadMore}
              text={translate('web.loadMore', 'Load More')}
            />
          </div>
        )}
      </div>
    </div>
  );
}
